import e from "../../hooks/useResizeObserver.js";
import t from "../../utils/classNames.js";
import n from "./ApplicationActionBar.js";
import r from "./AppMenu.js";
import i from "./MobileSubmoduleNavigation.js";
import a from "./MobileAppMenu.js";
import { NavItems as o } from "./NavItems.js";
import s, { forwardRef as c, useCallback as l, useImperativeHandle as u, useRef as d } from "react";
import { isEmpty as f } from "es-toolkit/compat";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
//#region src/components/applicationHeader/ApplicationHeader.tsx
var h = 768, g = c((c, g) => {
	let { homeRoute: v = "", brandLogo: y, darkBrandLogo: b, label: x, className: S, appNavigator: C, appNavigatorClassName: w, appMenuItems: T, navItems: E, actionBarItems: D = [], onToggleAppMenu: O = () => {}, ...k } = c, A = d(null), [j, M] = e(), N = M?.contentRect;
	u(g, () => j, [j]);
	let P = l((e) => {
		if (N) {
			let t = N[e];
			return typeof t == "number" && Math.round(t);
		}
	}, [N])("width") || window.innerWidth, F = P <= h, I = !f(D), L = t("ApplicationHeader", "user-select-none", F && "mobile", S && S), R = {
		"--application-header-brand-logo": y ? `url(${JSON.stringify(y)})` : void 0,
		"--application-header-dark-brand-logo": b ? `url(${JSON.stringify(b)})` : void 0
	};
	return /* @__PURE__ */ m("nav", {
		...k,
		className: L,
		ref: j,
		style: R,
		children: [F && /* @__PURE__ */ m(s.Fragment, { children: [/* @__PURE__ */ p(a, {
			homeRoute: v,
			appMenuItems: T,
			appNavigator: C,
			onToggleAppMenu: O
		}), /* @__PURE__ */ m("div", {
			className: "flex-1-1-0 display-flex gap-10",
			children: [
				/* @__PURE__ */ p(i, {
					className: "flex-1-1",
					label: x,
					navItems: E
				}),
				I && /* @__PURE__ */ p(_, {}),
				/* @__PURE__ */ p(n, {
					className: "mobile",
					nodeRef: A,
					items: D
				})
			]
		})] }), !F && /* @__PURE__ */ m(s.Fragment, { children: [
			/* @__PURE__ */ p("div", {
				className: "navbar-header",
				children: /* @__PURE__ */ p("span", {
					className: "navbar-brand",
					children: v
				})
			}),
			x && /* @__PURE__ */ p(r, {
				label: x,
				appMenuItems: T,
				appNavigator: C,
				appNavigatorClassName: w,
				onToggleAppMenu: O
			}, "AppMenu"),
			f(E) && /* @__PURE__ */ p("ul", { className: "SubmoduleNavigation nav" }),
			!f(E) && /* @__PURE__ */ p(o, {
				navItems: E,
				containerWidth: P,
				actionBarItems: D
			}, "NavItems"),
			/* @__PURE__ */ p(n, {
				nodeRef: A,
				items: D
			})
		] })]
	});
}), _ = () => /* @__PURE__ */ p("div", {
	className: "divider display-flex align-items-center",
	children: /* @__PURE__ */ p("div", { className: "width-3 height-20 bg-lighter" })
});
//#endregion
export { g as ApplicationHeader, g as default };

//# sourceMappingURL=ApplicationHeader.js.map